module.exports = __webpack_public_path__ + "img/xindcb.78147349.svg";